/**
 * Sliders
 */

var Slider = (function($) {
  function initSlider() {
    if (!$(".home-hero-slider").length) {
      return;
    }

    new Swiper(".home-hero-slider", {
      loop: true,
      speed: 800,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },

      on: {
        init: function() {
          handleHeroVideo(this);
        },

        slideChange: function() {
          handleHeroVideo(this);
        }
      }
    });
  }

  function handleHeroVideo(swiper) {
    var $slides = $(swiper.slides);

    // Stop, reset and mute all videos
    $slides.find("video").each(function() {
      this.pause();
      this.currentTime = 0;
      this.muted = true;

      $(this).removeClass("is-unmuted");
    });

    // Play video inside active slide
    var $activeSlide = $(swiper.slides[swiper.activeIndex]);
    var video = $activeSlide.find("video").get(0);

    if (video) {
      video.play().catch(function() {});
    }
  }

  function initVideoSound() {
    $(".home-hero-slider").on("click", ".home-hero-slide__video", function(e) {
      e.stopPropagation();

      this.muted = !this.muted;

      $(this).toggleClass("is-unmuted", !this.muted);
    });
  }

  function initServiceSlider() {
    /**
     * Mobile slider
     */
    if ($(".home-services-slider-mobile").length) {
      new Swiper(".home-services-slider-mobile", {
        slidesPerView: "auto",
        spaceBetween: 20,
        loop: false,
        speed: 900,
        grabCursor: true,
        watchOverflow: true,
        resistanceRatio: 0.75,

        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true
        },

        freeMode: {
          enabled: true,
          momentum: true
        }
      });
    }

    /**
     * Desktop slider
     */
    if ($(".home-services-slider").length) {
      var desktopServicesSlider = new Swiper(".home-services-slider", {
        slidesPerView: 1,
        loop: true,
        speed: 900,
        effect: "fade",

        fadeEffect: {
          crossFade: true
        },

        allowTouchMove: false,

        on: {
          init: function() {
            updateServiceTitle(this.realIndex);
          },

          slideChange: function() {
            updateServiceTitle(this.realIndex);
          }
        }
      });

      $(".home-services-slider").on("click", ".swiper-slide-active", function(
        e
      ) {
        if ($(e.target).closest("a, button").length) {
          return;
        }

        desktopServicesSlider.slideNext();
      });
    }
  }

  function updateServiceTitle(index) {
    $(".home-services__subtitle")
      .removeClass("is-active")
      .filter('[data-index="' + index + '"]')
      .addClass("is-active");
  }

  function init() {
    if (!$(".swiper").length) {
      return;
    }

    initSlider();
    initServiceSlider();
    initVideoSound();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Slider.init);
